<template>
  <div class="row">
    <autocomplete
      :debounce-time="300"
      :get-result-value="getResultValue"
      :search="lookup"
      class="col"
      placeholder="Search by Name, CAS, SMILES, DTXSID, DTXCID, InChI or InChIKey"
      @submit="submit"
    >
      <template #result="{ result, props }">
        <li
          class="container"
          v-bind="props"
        >
          <div class="row item">
            <img
              :src="`${RESOLVER_URL}/render?query=${result.chemical.cid || encodeURIComponent(result.chemical.smiles)}`"
              alt=""
              class="col-1 item-img"
            />
            <div class="col item-body">
              {{ getResultValue(result.chemical) }}
            </div>
          </div>
        </li>
      </template>
    </autocomplete>

    <b-checkbox
      v-model="fuzzy"
      v-b-tooltip
      class="col-1 options mt-3"
      title="Include substring matches"
    >
      Fuzzy
    </b-checkbox>
  </div>
</template>

<script>
import { RESOLVER_URL } from '@/main'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'

export default {
  components: {
    autocomplete: Autocomplete,
  },

  data: () => ({
    fuzzy: false,
  }),

  computed: {
    RESOLVER_URL() {
      return RESOLVER_URL
    },
  },

  methods: {
    getResultValue(result) {
      return result.name || result.casrn || result.sid
    },

    async lookup(query) {
      if (!query || query.trim().length < 3) return []

      let { data } = await this.$axios.get(
        `${RESOLVER_URL}/lookup?query=${encodeURIComponent(query)}&fuzzy=${this.fuzzy ? 'Anywhere' : 'Start'}`,
      )
      return data.filter((c) => !!c.chemical.smiles)
    },

    submit(item) {
      if (!item || !item.chemical) return

      const query = item.chemical.sid || item.chemical.cid || item.chemical.casrn || item.chemical.smiles
      this.$axios.get(`${RESOLVER_URL}/lookup?query=${encodeURIComponent(query)}&mol=true`).then((response) => {
        if (response.data && response.data[0].chemical && response.data[0].chemical.mol)
          this.$emit('searchcompleted', response.data[0].chemical)
      })
    },
  },
}
</script>

<style scoped>
.item-img {
  margin-left: 40px;
}

.options {
  vertical-align: middle;
}

.item-body {
  vertical-align: middle;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
